import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { BreadcrumbItem } from '../../models/breadcrumb-item';
import { BreadcrumbService } from '../../services/breadcrumb.service';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForbiddenComponent implements OnInit, OnDestroy {
  private breadcrumb: BreadcrumbItem = {
    url: 'forbidden',
    label: 'Недостаточно прав',
    name: 'forbidden',
  };

  constructor(
    private bs: BreadcrumbService,
  ) {}

  ngOnInit(): void {
    this.bs.add(this.breadcrumb);
  }

  ngOnDestroy(): void {
    this.bs.remove(this.breadcrumb);
  }
}
